var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-empty',{staticStyle:{"margin-top":"10vh"},attrs:{"image":_vm.errorImage,"description":_vm.$route.query.msg}},[_c('van-button',{staticClass:"x-button",attrs:{"round":"","type":"info"},on:{"click":_vm.goHome}},[_vm._v("返回")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }